import { addAlert, selectLoading } from "modules/notification";
import React from "react";
import {connect, useSelector} from "react-redux";
import SerialNumTableComponent from "./serialNumTable.component";
import { useHistory } from "react-router-dom";
import { GENERATE_SN, ROOT } from "../../../config/serial-number.route";
import { fetchTableLength } from "../../../redux";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";

function SerialNumTableContainer({
  hasSerialNumberEditAccessRight,
  hasSerialNumberGenerateAccessRight,
  isFetching,
  isLengthFetching,
  listingSerialNumberData,
  page,
  language,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  length,
  search,
  addSuccessAlert,
  handleReload,
  handleStatusChange,
  paginationOptions,
  lang,
  handleViewDetail,
  showAdditionalInfo = false,
  additionalFields,
  isSearchResult,
  userLang,
  isError,
  displayLang,
  isBranchDropdownLoading,
  isProductDropdownLoading,
  handleSelectAvailable,
  handleDeselectAvailable,
  handleSelectSn,
  totalFiltered,
  selectedEncs,
  handleBlockStatusChange,
}) {
  const history = useHistory();
  const canUpdateStatus = useSelector((state) =>
    canAccess(state, AccessRights.Qr.SERIAL_NUMBER_SUSPEND_REACTIVATE));

  const handleAddSerialNumber = () => {
    history.push(GENERATE_SN);
  };

  const handleViewSerialNumberDetails = ({ enc }) => {
    handleViewDetail(`${ROOT}/details/${enc}`);
  };

  return (
    <SerialNumTableComponent
      hasSerialNumberEditAccessRight={hasSerialNumberEditAccessRight}
      hasSerialNumberGenerateAccessRight={hasSerialNumberGenerateAccessRight}
      rows={listingSerialNumberData}
      page={page}
      rowsPerPage={rowsPerPage}
      language={language}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      isFetching={isFetching}
      isLengthFetching={isLengthFetching}
      disabledPagination={isFetching || isLengthFetching}
      length={length}
      search={search}
      addSuccessAlert={addSuccessAlert}
      handleAddSerialNumber={handleAddSerialNumber}
      handleReload={handleReload}
      handleViewSerialNumberDetails={handleViewSerialNumberDetails}
      handleStatusChange={handleStatusChange}
      paginationOptions={paginationOptions}
      lang={lang}
      showAdditionalInfo={showAdditionalInfo}
      additionalFields={additionalFields}
      isSearchResult={isSearchResult}
      userLang={userLang}
      isError={isError}
      displayLang={displayLang}
      handleSelectAvailable={handleSelectAvailable}
      handleDeselectAvailable={handleDeselectAvailable}
      totalFiltered={totalFiltered}
      selectedEncs={selectedEncs}
      handleSelectSn={handleSelectSn}
      isBranchDropdownLoading={isBranchDropdownLoading}
      isProductDropdownLoading={isProductDropdownLoading}
      canUpdateStatus={canUpdateStatus}
      handleBlockStatusChange={handleBlockStatusChange}
    />
  );
}

const mapStateToProps = (state) => ({
  userLang: state.profile.language,
  isLengthFetching: selectLoading(state, fetchTableLength.typePrefix),
  displayLang: state.additionalInfo.displayLang,
});

const mapDispatchToProps = (dispatch) => ({
  addSuccessAlert: (value) =>
    dispatch(addAlert({ severity: "success", message: value })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SerialNumTableContainer);
